import React, { useState } from 'react';
import './style.scss';
import LearnMore from '../LearnMore';

const CerebrySubheader = () => {
    const [toggleLearnMore, setToggleMore] = useState(false);

    const handleToggleLearnMore = () => {
        setToggleMore(!toggleLearnMore);
    }
    return (
        <div className={['cerebry__subheader']}>
            <div className={['cerebry__subheader__title']}>
                Petition to ask Schools Principal to adopt Homework Management System urgently
            </div>
            <div onClick={handleToggleLearnMore} className={['cerebry__subheader__button']}>
                What is this about? Learn more
            </div>
            <div className={['underline']}></div>
            {
                toggleLearnMore === true &&
                <LearnMore handleToggleLearnMore={handleToggleLearnMore} />
            }
        </div>
    )
}

export default CerebrySubheader;
